module.exports = __webpack_public_path__ + "img/疾风.55a1b4fa.png";